import * as React from 'react'

interface IProps {}
export const Close: React.FCC<IProps> = ({}) => {
  return (
    <div className="bg-green rounded-[10px] flex flex-col items-center text-white text-center py-[40px] px-[20px] w-[360px]">
      <h2 className="font-header font-header text-[28px] leading-[36px] font-semibold">
        Closed
      </h2>

      <p className="font-body text-[20px] font-description leading-[30px] font-normal mt-[16px]">
        You just close customer portal.
        <span className="block my-[10px]" />
        You can close this tab as well and get back to plugin.
      </p>
    </div>
  )
}
